import React from 'react';
import MyGallery from "../Gallery/MyGallery";
import './ServicesPage.css';
import {useTranslation} from "react-i18next";

function SpecialConstructionsPage() {
    const { t } = useTranslation();
    const directory= "/images/eidikesKataskeves/";
    const filenames=[
        'VPR02604_Vasso_Paraschi.webp',
        'VPR02650_Vasso_Paraschi.webp',
        'VPR02753_Vasso_Paraschi.webp',
        'VPR02781_Vasso_Paraschi.webp',
        'VPR02849_Vasso_Paraschi.webp',
        'VPR02873_Vasso_Paraschi.webp',
        'VPR02888_Vasso_Paraschi.webp',
        'VPR02993_Vasso_Paraschi.webp',
        'VPR02997_Vasso_Paraschi.webp',
        'VPR03106-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR03246-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR03452_Vasso_Paraschi.webp',
        'VPR03504-Enhanced-NR_Vasso_Paraschi.webp'
    ];

    return (
        <div className="services-page">
            <h1>{t("Special Constructions")}</h1>
            <div className="services-info-container">
                <MyGallery directory={directory} filenames={filenames}/>
            </div>
        </div>
    );
}

export default SpecialConstructionsPage;
